module.exports = __webpack_public_path__ + "img/hks-bg.addf3055.jpg";